import { esc } from "../../utils/format.js";
export const badge = (s) => (
  <span className={"badge " + esc(s.toLowerCase().replaceAll(" ", "-"))}>
    {esc(s)}
  </span>
);
